import React, { Component } from "react";

class FrontendListing extends Component {
	static slug = "urm-frontend-listing";
	render() {
		if (this.props.__render_frontend_listing) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: this.props.__render_frontend_listing
					}}
				></div>
			);
		}
		return null;
	}
}

export default FrontendListing;
